import React, { memo } from "react";
import useStyles from "./styles";
import NoneData from "components/NoneData";
import HeaderLoyaltyOrder from "./Components/HeaderLoyaltyOrder";
import BodyLoyaltyOrder from "./Components/BodyLoyaltyOrder";
import FieldBody from "../FieldBody";
import moment from "moment";
import theme from "theme";

import { formatCash } from "config/constant";
import { Grid } from "@material-ui/core";

const formatDay = day => {
	return moment(day).format("DD/MM/YYYY");
};

const formatDayNotYear = day => {
	return moment(day).format("DD/MM");
};

const totalPoint = lists => {
	return lists.reduce((accumulator, current) => {
		return accumulator + (current.point || 0);
	}, 0);
};

const LoyaltyHistoryOrder = memo(props => {
	const classes = useStyles();
	const { listOrder, isMobile, height } = props;

	let listOrderFormat = listOrder?.sort(function (a, b) {
		return new Date(b?.createTime) - new Date(a?.createTime);
	});

	listOrderFormat = listOrderFormat?.filter(listItem => {
		return totalPoint(listItem?.items) !== 0;
	});

	return (
		<Grid classes={{ root: classes.root }} style={{ height: height }}>
			{!!listOrderFormat && listOrderFormat?.length > 0 ? (
				listOrderFormat.map((product, index) => (
					<Grid classes={{ root: classes.history }} key={index}>
						<Grid classes={{ root: classes.historyItem }}>
							<HeaderLoyaltyOrder product={product} />
							<Grid classes={{ root: classes.time }}>
								<Grid classes={{ root: classes.bodyTime }}>
									<FieldBody
										title="TG trả thưởng"
										value={
											product?.startTimeReward
												? `${formatDayNotYear(
														product?.startTimeReward
												  )} - ${formatDay(
														product?.endTimeReward
												  )}`
												: "--"
										}
									/>
									<FieldBody
										title="TG giao thực tế"
										value={
											product?.deliveryTime
												? formatDay(
														product?.deliveryTime
												  )
												: "-"
										}
									/>
									<FieldBody
										title="Tổng điểm đã dùng"
										value={formatCash(
											totalPoint(product?.items) || 0
										)}
										color={theme.palette.error.light}
									/>
								</Grid>
							</Grid>
							<BodyLoyaltyOrder
								products={product?.items}
								product={product}
							/>
						</Grid>
					</Grid>
				))
			) : (
				<Grid
					classes={{ root: classes.centerPage }}
					style={{ height: isMobile ? height : 0 }}
				>
					<NoneData />
				</Grid>
			)}
		</Grid>
	);
});

export default LoyaltyHistoryOrder;
